module.exports = __webpack_public_path__ + "img/icon-corner.dafbd57c.svg";